import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pme-dental',
  templateUrl: './pme-dental.component.html',
  styleUrls: ['./pme-dental.component.scss']
})
export class PmeDentalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
